import { HiOutlineVideoCamera } from 'react-icons/hi2';
import { FiTarget } from "react-icons/fi";
import { IoLockClosedOutline } from "react-icons/io5";
import { FaRegCheckCircle } from "react-icons/fa";
import { BiDollar } from 'react-icons/bi';
import { FaArrowRight, FaArrowDown } from "react-icons/fa";






export default function Architecture() {
  const components = [
    {
      name: 'Video',
      icon: <HiOutlineVideoCamera />
    },
    {
      name: 'Prediction',
      icon: <FiTarget />
    },
    {
      name: 'Escrow',
      icon: <IoLockClosedOutline />
    },
    {
      name: 'Resolution',
      icon: <FaRegCheckCircle />
    },
    {
      name: 'Payout',
      icon: <BiDollar />
    }
  ];

  return (
    <section id="architecture" className="section architecture">
      <div className="container">
        <div className="section-header text-center">
          <h1>On-chain architecture</h1>
          <p>Built on secure and audited smart contracts</p>
        </div>

        <div className="architecture-diagram">
          <div className="arch-card">
            <div className="arch-flow">
              {components.map((component, index) => (
                <div key={index} className="arch-step-wrapper">
                  <div className="arch-component">
                    <div className="arch-icon">{component.icon}</div>
                    <div className="arch-name">{component.name}</div>
                    <div className="arch-step-number">Step {index + 1}</div>
                  </div>
                  {index < components.length - 1 && (
                    <>
                      <FaArrowRight className="arch-arrow-right" />
                      <FaArrowDown className="arch-arrow-down" />
                    </>
                  )}
                </div>
              ))}
            </div>

            <div className="arch-details">
              <div className="arch-detail-item">
                <p><span>Smart contract escrow</span> holds all USDC until resolution</p>
              </div>
              <div className="arch-detail-item">
                <p><span>Automated payouts</span> distribute winnings based on oracle results</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
